module.exports = __webpack_public_path__ + "img/online.8f48a151.svg";